// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"PasswordTab_buttonsWrapper__3klcv","buttonWrapper":"PasswordTab_buttonWrapper__F7EF1"};